import { gql } from "@apollo/client";

export const GET_LISTAR_MINUTA_JUSTIFICACIONES = gql`
    query GetJustificacionesMinuta {
        justificacionesMinuta {
            idJustificacionMinuta,
            descripcion
        }
    }
`;

export const adaptListarMinutaJustificaciones = (justificacion) => {
  return {
    idJustificacionMinuta: justificacion?.idJustificacionMinuta,
    descripcion: justificacion?.descripcion
  };
};

export const adaptListarMinutaJustificacionesArray = (justificaciones) => {
  return structuredClone(justificaciones)?.
  map((justificacion) => adaptListarMinutaJustificaciones(justificacion));
};